import { gql } from '@apollo/client'

export const PLAN_FRAGMENTS = gql`
  fragment PlanFragments on CommonSquidwardPlan {
    id
    sku
    name
    amount
    frequency
    rank
    isModularized
    cancelOffers {
      plan {
        sku
      }
      description
      coupon {
        code
      }
      activationType
    }
    modules {
      name
      description
      type
      enabled
      price
      features {
        name
        description
      }
      sortOrder
    }
    availablePlanTransitions {
        sku
        activationType
      }
  }
`

export const PLAN_QUERY = gql`
  query plan($sku: String!){
    plan(sku: $sku) {
      id
      sku
      name
      amount
      frequency
      rank
      isModularized
      cancelOffers {
        plan {
          sku
        }
        description
        coupon {
          code
        }
        activationType
      }
      modules {
        name
        description
        type
        enabled
        price
        features {
          name
          description
        }
      }
      availablePlanTransitions {
        sku
        activationType
      }
    }
  }
`

export const PLAN_GROUP_QUERY = gql`
  query getPlanGroups($skuGroup: [String!]) {
    planGroup(skuGroup: $skuGroup) {
      id
      sku
      name
      amount
      frequency
      rank
      modules {
        features {
          description
        }
      }
      availablePlanTransitions {
        sku
        activationType
      }
    }
  }
`

export default {}
